import React from 'react';
import { RegistrationStep } from '../../../../../Utils/constants';
import useFitnessVillageCopy from '../../../../../hooks/useFitnessVillageCopy';
import { IFormTabs } from '../../Types';
import { SurfaceProp } from '../../../../shared/dfcVillage/style';
import { TabButton, TabRow } from './style';

type Props = IFormTabs & SurfaceProp;

/** Sign in / Create account segmented control. Selected pill uses the surface's "on" tokens. */
const AuthenticationFormTabs: React.FC<Props> = ({ formType, onChangeFormHandler, surface }) => {
  const copy = useFitnessVillageCopy().auth;
  const isLogin = formType === RegistrationStep.Login;

  return (
    <TabRow surface={surface} role="tablist" aria-label={copy.eyebrow}>
      <TabButton
        surface={surface}
        active={isLogin}
        role="tab"
        aria-selected={isLogin}
        data-testid="login-tab"
        onClick={e => onChangeFormHandler(e, RegistrationStep.Login)}
      >
        {copy.signIn.tab}
      </TabButton>
      <TabButton
        surface={surface}
        active={!isLogin}
        role="tab"
        aria-selected={!isLogin}
        data-testid="signup-tab"
        onClick={e => onChangeFormHandler(e, RegistrationStep.SignUp)}
      >
        {copy.signUp.tab}
      </TabButton>
    </TabRow>
  );
};

export default AuthenticationFormTabs;
